<div class="container-form">

  <!-- Estado inicial: activar o desactivar -->
  <div *ngIf="step === 'intro'" class="row flex-column pb-2 align-items-start">
    <p class="text-white mb-2">
      {{ enabled
        ? 'Tenés la verificación en dos pasos activada en tu cuenta.'
        : 'Agregá una capa extra de seguridad pidiendo un código de tu app authenticator (ej. Google Authenticator) al iniciar sesión.' }}
    </p>

    <span *ngIf="error" class="s-sm booking text-danger mb-2">{{ error }}</span>

    <div class="mt-2">
      <button
        *ngIf="!enabled"
        type="button"
        class="btn border-white btn-send"
        style="margin-right: 1em;"
        [disabled]="loading"
        (click)="activate()"
      >
        {{ loading ? 'Activando...' : 'Activar verificación en dos pasos' }}
      </button>

      <button
        *ngIf="enabled"
        type="button"
        class="btn border-white btn-send"
        style="margin-right: 1em;"
        [disabled]="loading"
        (click)="deactivate()"
      >
        {{ loading ? 'Desactivando...' : 'Desactivar verificación en dos pasos' }}
      </button>

      <button type="button" class="btn border-white btn-send" (click)="close()">
        Cerrar
      </button>
    </div>
  </div>

  <!-- QR para escanear con la app authenticator -->
  <div *ngIf="step === 'qr'" class="row flex-column pb-2 align-items-start">
    <p class="text-white mb-2">
      Escaneá este código con tu app authenticator (Google Authenticator, Authy, etc.).
      La próxima vez que inicies sesión te vamos a pedir el código de 6 dígitos.
    </p>

    <img *ngIf="qrImage" [src]="qrImage" alt="Código QR para verificación en dos pasos" class="two-factor-qr" />

    <p *ngIf="secret" class="text-white-50 s-sm mt-2">
      ¿No podés escanear el código? Ingresá esta clave manualmente en tu app: <br>
      <strong class="text-white">{{ secret }}</strong>
    </p>

    <div class="mt-3">
      <button type="button" class="btn border-white btn-send" (click)="close()">
        Listo
      </button>
    </div>
  </div>

</div>
